import { render, staticRenderFns } from "./DownloadInfoNew.vue?vue&type=template&id=29bf4cff&scoped=true&"
import script from "./DownloadInfoNew.vue?vue&type=script&lang=js&"
export * from "./DownloadInfoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf4cff",
  null
  
)

export default component.exports